export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de contenedores"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedor"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back to containers list"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Container"])}
        }
      }
    }
  })
}